import fastdom from "fastdom"

import {
  LAYOUT_UPDATE_EVENT_NAME as layoutUpdateEventName,
  LAYOUT_UPDATE_EVENT_TARGET as layoutUpdateEventTarget,
} from "fc-ads/fc-ads"
import throttle from "utils/throttle"

export const CLASS_NAME = "forecast-table-expand-tooltip"
export const CLASS_NAME_ARROW_UP = "has-arrow-up"
export const CLASS_NAME_ARROW_DOWN = "has-arrow-down"
export const QUERY_STRING_SCROLL_CONTAINER = "[data-scroll-container]"

export function create(textContent) {
  const el = document.createElement("div")
  el.className += CLASS_NAME
  el.textContent = textContent || ""
  return el
}

export function append(el, parent, next) {
  fastdom.mutate(() => {
    parent.appendChild(el)
    next(null, el)
  })
}

export function remove(el, next) {
  if (el.parentNode) {
    fastdom.mutate(() => {
      el.remove()
      next(null, el)
    })
    return
  }

  next(null, el)
}

export function move(el, x, y, next) {
  /* eslint-disable no-param-reassign */
  el.style.willChange = "top, left"
  fastdom.mutate(() => {
    el.style.top = `${y}px`
    el.style.left = `${x}px`
    el.style.willChange = null
    next(null, { el, x, y })
  })
  /* eslint-enable no-param-reassign */
}

export function addArrowUp(el, next) {
  fastdom.mutate(() => {
    el.classList.add(CLASS_NAME_ARROW_UP)
    el.classList.remove(CLASS_NAME_ARROW_DOWN)
    next(null, el)
  })
}

export function addArrowDown(el, next) {
  fastdom.mutate(() => {
    el.classList.add(CLASS_NAME_ARROW_DOWN)
    el.classList.remove(CLASS_NAME_ARROW_UP)
    next(null, el)
  })
}

export function getClosestScrollContainer(el) {
  return el.closest(QUERY_STRING_SCROLL_CONTAINER)
}

export function listenScroll(el, listener) {
  const throttled = throttle(listener, 20)
  el.addEventListener("scroll", throttled)
  return () => el.removeEventListener("scroll", throttled)
}

export function listenResize(listener) {
  const throttled = throttle(listener, 3000)
  window.addEventListener("resize", throttled)
  return () => window.removeEventListener("resize", throttled)
}

export function listenMutations(el, listener) {
  const observer = new MutationObserver(throttle(listener, 500))
  observer.observe(el, { attributes: true })
  return () => observer.disconnect()
}

export function listenLayoutUpdate(listener) {
  // the event dispatcher is already debounced
  window[layoutUpdateEventTarget].addEventListener(layoutUpdateEventName, listener)
  return () => window[layoutUpdateEventTarget].removeEventListener(layoutUpdateEventName, listener)
}
